module.exports = {
  submit: {
    all: {
      saveTimeRecordings: 'Zeiterfassung speichern',
    },
    resetUser: {
      all: 'Passwort zurücksetzen',
    },
    timeRecord: {
      all: 'Eintrag übernehmen',
    },
    application: {
      showRegister: 'Bewerbung abschließen',
      showRegisterStep: 'Speichern & Weiter',
    },
    registration: {
      showRegister: 'Registrierung abschließen',
    },
    saveTimeRecordings: {
      timeRegistration: 'Zeiterfassung speichern',
      shippingOrder: 'Lieferschein-Zeiten speichern',
    },
  },
  // TODO: check if in use,
  // decisionComponent: {
  //   all: {
  //     all: 'Senden',
  //   },
  // },
  ok: {
    all: {
      all: 'OK',
    },
  },
  showReplace: {
    shippingOrders: {
      all: 'Lieferschein ersetzen',
    },
  },
  export: {
    employee: {
      all: 'Mitarbeiter exportieren',
      workHours: 'Stundenlisten exportieren',
    },
  },
  showInsert: {
    projects: {
      all: 'Projekt',
      allInOne: 'Projekt',
    },
    projectTerms: {
      all: 'Termin',
    },
    projectTermJobs: {
      all: 'Planstelle',
      mass: 'Mehrere Planstellen',
    },
    employees: {
      all: 'Mitarbeiter',
    },
    jobs: {
      all: 'Job',
    },
    jobPrices: {
      all: 'Preise',
    },
    flatScaleEntry: {
      all: 'Preisstaffel-Eintrag einfügen',
    },
    customers: {
      all: 'Kunde',
    },
    customerContacts: {
      all: 'Auftraggeber',
    },
    contractors: {
      all: 'Sub-Unternehmer',
    },
    contractorContacts: {
      all: 'Ansprechpartner',
    },
    shippingOrders: {
      all: 'Lieferschein',
    },
    costCenters: {
      all: 'Kostenstelle',
    },
    absence: {
      all: 'Abwesenheit',
    },
  },
  showEdit: {
    projects: {
      all: 'Projekt bearbeiten',
    },
    projectTerms: {
      all: 'Termin bearbeiten',
    },
    projectTermJobs: {
      all: 'Planstelle bearbeiten',
    },
    employees: {
      all: 'Mitarbeiter bearbeiten',
    },
    jobs: {
      all: 'Job bearbeiten',
    },
    locationOptions: {
      all: 'Location-Link bearbeiten',
    },
    shippingOrders: {
      projectTerm: 'Tages-Liefschein-Verwaltung öffnen',
      all: 'Liefschein-Verwaltung öffnen',
    },
    timeRecordings: {
      timeRegistration: 'Ist-Zeiten erfassen',
      shippingOrder: 'Liefschein-Zeiten erfassen',
      all: 'Zeiten erfassen',
    },
    timeRecordings_projectTerm: {
      timeRegistration: 'Ist-Tages-Zeiten erfassen',
      shippingOrder: 'Liefschein-Tages-Zeiten erfassen',
      all: 'Tages-Zeiten erfassen',
    },
    documents: {
      invoice: 'Rechnung bearbeiten',
    },
    absence: {
      all: 'Abwesenheit bearbeiten',
    },
    customers: {
      all: 'Kunde bearbeiten',
    },
    customerContacts: {
      all: 'Auftraggeber bearbeiten',
    },
    contractors: {
      all: 'Sub-Unternehmer bearbeiten',
    },
    contractorContacts: {
      all: 'Ansprechpartner bearbeiten',
    },
    employeeReports: {
      all: 'Stundenliste bearbeiten',
    },
    jobPrices: {
      all: 'Preis bearbeiten',
    },
  },
  showList: {
    projectTermJobs: {
      all: 'Zu den Planstellen-Details',
    },
    documents: {
      all: 'Zu den Dokumenten',
    },
  },
  showLocation: {
    projectTerms: {
      all: 'Location aufrufen',
    },
  },
  showExport: {
    employeeReports: {
      all: 'Stundenlisten exportieren',
    },
  },
  edit: {
    projectTermJobStatus: {
      read: 'Zusagen',
      agreed: 'Zusagen',
      revoked: 'Absagen',
      applied: 'Bewerben',
      waitlisted: 'Auf Warteliste setzen',
    },
    advertisements: {
      agreed: 'Zusagen',
      revoked: 'Absagen',
      applied: 'Bewerben',
      waitlisted: 'Auf Warteliste setzen',
    },
  },
  alreadyEdited: {
    projectTermJobStatus: {
      read: 'Zugesagt',
      agreed: 'Zugesagt',
      revoked: 'Abgesagt',
      applied: 'Beworben',
      waitlisted: 'Auf Warteliste',
    },
  },
  delete: {
    projects: {
      all: 'Projekt löschen',
    },
    projectTerms: {
      all: 'Termin löschen',
    },
    projectTermJobs: {
      all: 'Planstelle löschen',
    },
    employees: {
      all: 'Mitarbeiter löschen',
    },
    jobs: {
      all: 'Job löschen',
    },
    flatScaleEntry: {
      all: 'Preisstaffel-Eintrag löschen',
    },
    costCenter: {
      all: 'Kostenstelle löschen',
    },
    absence: {
      all: 'Abwesenheit löschen',
    },
  },
  choose: {
    timeRecordings: {
      timeRegistration: 'Ist - Zeiten',
      shippingOrder: 'Lieferschein - Zeiten',
    },
  },
  moveToProject: {
    projectTerms: {
      all: 'Termine verschieben',
    },
  },
  showMove: {
    all: {
      all: 'Verschieben',
    },
    customerContacts: {
      all: 'Auftraggeber verschieben',
      toCustomer: 'Auftraggeber anderem Kunden zuweisen',
    }
  },
  advertise: {
    all: {
      all: 'ausschreiben',
    },
    projectTermJobs: {
      all: 'ausschreiben',
    },
  },
  setActive: {
    jobs: {
      all: 'aktivieren',
    },
  },
  setInactive: {
    jobs: {
      all: 'deaktivieren',
    },
  },
  setEmployeeJobPrice: {
    all: {
      all: 'Preise festlegen',
    },
    employee: {
      all: 'Preise festlegen',
    },
  },
  lazyload: {
    projects: {
      all: 'Weitere Projekte laden',
    },
    projectTerms: {
      all: 'Weitere Termine laden',
    },
    projectTermJobs: {
      all: 'Weitere Planstellen laden',
    },
    projectTermJobApplications: {
      all: 'Weitere Bewerber laden',
    },
    employees: {
      all: 'Weitere Mitarbeiter laden',
    },
    employeeReports: {
      all: 'Weitere Stundenlisten laden',
    },
    jobs: {
      all: 'Weitere Jobs laden',
    },
    jobPrices: {
      all: 'Weitere Preise laden',
    },
    customers: {
      all: 'Weitere Kunden laden',
    },
    customerContacts: {
      all: 'Weitere Auftraggeber laden',
    },
    contractors: {
      all: 'Weitere Sub-Unternehmer laden',
    },
    contractorContacts: {
      all: 'Weitere Ansprechpartner laden',
    },
    statusFlags: {
      all: 'Weitere Status-Elemente laden',
    },
    costCenters: {
      all: 'Weitere Kostenstellen laden',
    },
    documents: {
      all: 'Weitere Dokumente laden',
    },
    advertisements: {
      all: 'Weitere Ausschreibungen laden',
    },
    absence: {
      all: 'Weitere Abwesenheiten laden',
    },
  },
  navToList: {
    all: {
      all: 'Liste öffnen',
    },
    projects: {
      all: 'Projekt-Liste öffnen',
    },
    absence: {
      all: 'Liste der Abwesenheiten öffnen',
    },
  },
  sendConfirmation: {
    email: {
      mail: 'Bestätigung versenden',
      email: 'Bestätigung versenden',
      all: 'Bestätigung versenden',
    },
    mobile: {
      mobile: 'Bestätigung versenden',
      all: 'Bestätigung versenden',
    },
  },
  selectAlternativeTab: {
    all: {
      all: 'Tab wechseln',
    },
  },
  openLocation: {
    all: {
      all: 'aufrufen',
    },
    location: {
      all: 'aufrufen',
    },
  },
  download: {
    all: {
      invoice: 'Rechnung herunterladen',
      creditNote: 'Gutschrift herunterladen',
    },
    offers: {
      all: 'Angebot herunterladen',
    },
  },
  editStatus: {
    project: {
      request: 'Unverbindliche Anfrage stellen',
      order: 'Kostenpflichtig bestellen',
      cancel: 'Stornieren',
    },
  },
  requestOffer: {
    project: {
      all: 'Angebot anfordern',
    },
  },
  showAdminPanel: {
    all: {
      all: 'Admin Panel öffnen',
    },
  },
  updateAllStatusFlags: {
    all: {
      all: 'Update All Status-Flags',
    },
  },
  updateAllEmployeeReports: {
    all: {
      all: 'Update All Employee-Reports',
    },
  },
  showProcess: {
    all: {
      all: 'Abarbeiten',
    },
    advertisements: {
      all: 'Ausschreibungen abarbeiten',
    },
  },
  submitAndRedo: {
    all: {
      all: 'Übernehmen & wiederholen',
      save: 'Speichern & wiederholen',
    },
    process: {
      all: 'Übernehmen & Verarbeitung wiederholen',
      save: 'Speichern & Verarbeitung wiederholen',
    },
  },
  submitAndOrder: {
    all: {
      all: 'Übernehmen & bestellen',
      save: 'Speichern & bestellen',
    },
  },
  redo: {
    all: {
      all: 'Wiederholen',
    },
    process: {
      all: 'Verarbeitung wiederholen',
    },
  },
  assign: {
    all: {
      all: 'zuweisen',
      empty: 'Zuweisung leeren',
    },
    nrOfElementsPerJob: {
      all: 'Jobs zuweisen',
      empty: 'Job - Zuweisung leeren',
    },
  },
}